import { render, staticRenderFns } from "./ProcedureHistoryDetails.vue?vue&type=template&id=6e52e25d"
import script from "./ProcedureHistoryDetails.vue?vue&type=script&lang=js"
export * from "./ProcedureHistoryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports